export const getMembersRoute = () => '/members';
export const getMemberCreateRoute = () => '/members/create';
export const getMemberEditRoute = (memberId = null) => '/members/' + (memberId ?? ':memberId');